
<div class="about_us_wrap">
    <div class="our_mission_sections">
        <div class="our_mission_overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="mission_content">
                        <h1>
                            <b style="font-weight: 600;" class="OpenSansFonts">Trinka</b>のミッション</h1>
                        <span>世界の誰もが英語でのライティングを簡単に行えるようにする
                            <br> それが私たちのミッションです
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="who_we_are_sections">
        <div class="container">
            <div class="row column_reverse">
                <div class="col-lg-8">
                    <div class="whot_we_are_content">
                        <h2>
                            <span class="OpenSansFonts">Trinka</span>について</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Trinka（トリンカ）を作り上げた私たちは、コミュニケーションのバリアフリー化を目指し日々挑戦を続ける、翻訳者や英文校正者など言語のスペシャリスト・ITエンジニア・データサイエンティストの専門家集団です。学術に関わるものから日常生活に関わるものまで、あらゆる人、あらゆる種類のコミュニケーションをサポートするツールを開発しています。
                            <br>
                            <span class="OpenSansFonts">Trinka</span>を運営するエナゴは、15年のグローバルな実績を持つ多国籍企業、クリムゾンインタラクティブの一部門です。クリムゾンインタラクティブは、これまで、125か国以上で20万人以上のお客様にサービスを提供し、600人の社員と5000人の契約社員を抱え、東京、北京、ソウル、ニュージャージー、ロンドンなど、世界10都市に現地事務所を設けています。</p>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="who_we_are_img">
                        <img src="assets/images/whoWeAre_aboutus.png" alt="私たちについて - 文法 チェック">
                    </div>
                </div>
            </div>
            <div class="row column_reverse prodcutName_sections">
                <div class="col-lg-4">
                    <div class="who_we_are_img">
                        <img src="assets/images/TrinkaD'Cunha.jpg" alt="Trinka D'Cunha">
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="whot_we_are_content">
                        <h2>ツール名
                            <span class="OpenSansFonts">Trinka</span>の由来</h2>
                        <div class="HeadingSubLine"></div>
                        <p>ひとりの人間のインスピレーションや献身的な作業、ビジョンが周囲を感化し突き動かすことがあります。当社の言語の専門家
                            <span class="OpenSansFonts">Trinka D’Cunha</span>もそんなひとりで、プロジェクトを第1日目から率先し、この最新のAIツールを完成に導きました。これにより彼女は、知のコミュニケーションに関わる言語の壁を取り除くという自らのミッションを大きく前進させました。
                            <span class="OpenSansFonts">Trinka</span>は彼女の名前を冠していますが、私たちにとってそれはごく自然な流れだったのです。</p>
                        <p>高精度の校正・<a [routerLink]="['/grammar-checker']" class="text-link">文法チェック</a>ツールを作り上げるにあたっては、高い意欲をもって課題に取り組んだチームの一人一人が欠くことのできない存在でした。この革新的な製品は、何年にもわたる献身的な共同作業の賜物で、それぞれの想いと専門技術がここに結晶しているのです。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="make_in_india_section">
        <div class="made_in_india_overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-md-8">
                    <div class="made_in_india_content">
                        <h2>メイド・イン・インディア</h2>
                        <div class="HeadingSubLine"></div>
                        <p>IT業界におけるインドの躍進は目覚ましく、今や世界のITのハブと言っても過言ではありません。</p>
                        <p>しかしインドが急成長を遂げる一方、インド製のIT製品で世界を席巻するものはなかなか生まれてきませんでした。そんな状況に、インド発の企業として私たちは一石を投じたかったのです。Trinkaの完成はその第一歩です。構想から制作までの全てをインドで行い、人工知能、自然言語処理の世界で一つの大きな業績を打ち立てることができたと、私たちは自負しています。</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="made_in_india_img">
                        <img src="assets/images/madeInIndia.png" alt="made in india - 英文校正">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="about_crimson_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="about_crimson_content">
                        <h2>クリムゾンインタラクティブ
                            <br>について</h2>
                        <div class="HeadingSubLine"></div>
                        <p>2005年創設のクリムゾンインタラクティブは、研究・出版ソリューションのグローバルリーダーとして、研究者、出版社、大学、企業からパートナーとして選ばれている多国籍企業です。これまで、世界125か国以上、20万人のお客様にサービスを提供してきました。個人以外では、MIT、プリンストン大学、コロンビア大学、オックスフォード大学などの一流大学や、トヨタ、ワイリー、エルゼビア、キャプジェミニ、パナソニック、富士通、ギネス世界記録、日立などの企業と取引をしています。</p>
                        <p>エナゴ、ユレイタス、ボックスタブ、
                            <span class="OpenSansFonts">Trinka</span>、エナゴライフサイエンス、などのブランドを持つクリムゾンでは、学術出版ソリューション、e-ラーニング、ローカライズ、メディカルコミュニケーション、人工知能、メディアソリューションなどを専門とし、ヘルスケアやバイオ医薬品企業のグローバルメディカルコミュニケーションパートナーとなっています。東京、ソウル、北京、イスタンブール、上海、ロンドン、ニュージャージー、ニューヨークをはじめ世界10都市にオフィスを構え、グローバルに事業を展開しています。</p>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="about_crimson_img">
                        <img src="assets/images/aboutCrimson.jpg" alt="クリムゾンについて - 英文チ ェッカー">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="crimson_brand_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="crimson_brand_content">
                        <h2>クリムゾンインタラクティブの事業</h2>
                        <div class="HeadingSubLine"></div>
                        <ul>
                            <li>
                                <a href="https://www.enago.com/" class="enago_crimson" target="_blank">
                                    <div class="brand_overlay"></div>
                                    <img src="assets/images/enago-crimson.png" alt="enago">
                                    <div class="text_overlay">
                                        <p>英語論文
                                            <br>校正サービス</p>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.ulatus.com/" class="ulatus_crimson" target="_blank">
                                    <div class="brand_overlay"></div>
                                    <img src="assets/images/ulatus-crimson.png" alt="ulatus">
                                    <div class="text_overlay">
                                        <p>論文翻訳・学術
                                            <br>翻訳サービス</p>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.voxtab.com/" class="voxtab_crimson" target="_blank">
                                    <div class="brand_overlay"></div>
                                    <img src="assets/images/voxtab-crimson.png" alt="voxtab">
                                    <div class="text_overlay">
                                        <p>テープ起こし
                                            <br>サービス</p>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="https://cloud.trinka.ai/signup?_rg=JP" class="trinka_crimson" target="_blank">
                                    <div class="brand_overlay"></div>
                                    <img src="assets/images/trinka-crimson.png" alt="trinka">
                                    <div class="text_overlay">
                                        <p>AI搭載・自動
                                            <br>英文校正ツール </p>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="https://lifesciences.enago.com/" class="lifes_crimson" target="_blank">
                                    <div class="brand_overlay"></div>
                                    <img src="assets/images/lifes-crimson.png" alt="lifesciences">
                                    <div class="text_overlay">
                                        <p>メディカル
                                            <br>コミュニケーション</p>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="global_offices">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>各国の現地オフィス</h2>
                    <div class="HeadingSubLine"></div>
                    <p>世界各国の拠点より、研究者の皆様にサービスを提供しています。</p>
                    <div class="global-presence-wrap mart-20">
                        <div class="global-maps" style="position: relative;">
                            <div class="row">
                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap usa marr-10" id="usa" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name OpenSansFonts">ニュージャージー
                                        <br />（アメリカ）</div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap usa padb-20" id="usaview">
                                    <div class="row">
                                        <div class="col-md-12 col-xs-12 global-location">
                                            <div class="location-wrap OpenSansFonts" style="margin-left: 50px;">
                                                <h3>New Jersey, USA</h3>
                                                <p class="marb-10">
                                                    <br>&nbsp;
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap korea marr-20" id="korea" onclick="viewlocation(id)">

                                    <div class="map-box"></div>
                                    <div class="location-name OpenSansFonts">ソウル
                                        <br>（韓国）</div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap korea padb-20" id="koreaview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap OpenSansFonts">
                                            <h3>Seoul, Korea</h3>
                                            <p>Crimson Interactive Korea Co., Ltd.
                                                <br> #803-74, 1-Dong, 775, Gyeongin-ro, Yeongdeungpo-gu, Seoul, Republic of Korea
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap china marr-20" id="china" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name OpenSansFonts">北京/上海
                                        <br>（中国）</div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap china padb-20" id="chinaview">
                                    <div class="row">
                                        <div class="col-md-6  col-sm-6  col-xs-12 global-location">
                                            <div class="location-wrap OpenSansFonts" style="margin-left: 50px;">
                                                <h3>Beijing, China</h3>
                                                <p class="marb-10">Room 607, Attempt Center, No. A6 Zhongguancun South Street, Haidian District,
                                                    Beijing, China - 100086
                                                    <br>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-md-6  col-sm-6 col-xs-12  global-location">
                                            <div class="location-wrap OpenSansFonts" style="margin-left: 50px;">
                                                <h3>Shangai, China</h3>
                                                <p class="marb-10">Room 101, No. 110, Tianlinshiyicun, Xuhui District, Shanghai 200233
                                                    <br>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap japan marr-20 active" id="japan" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name OpenSansFonts">東京
                                        <br>（日本）</div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap japan padb-20 show" id="japanview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap OpenSansFonts">
                                            <h3>Tokyo, Japan</h3>
                                            <p class="marb-10">Crimson Interactive K.K.
                                                <br> 4th Daini-Denpa Building, 2-14-10 Soto-Kanda, Chiyoda-ku, Tokyo, 101-0021,
                                                Japan
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap india" id="india" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name OpenSansFonts">ムンバイ
                                        <br>（インド）</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap india padb-20" id="indiaview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap OpenSansFonts">
                                            <h3>Mumbai, India</h3>
                                            <p class="marb-10">Crimson Interactive
                                                <br> 1001, 10th Floor, Techniplex - II, Veer Savarkar Flyover, S. V. Road, Goregaon
                                                (W), Mumbai 400062, India
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap uk" id="uk" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name OpenSansFonts">ロンドン
                                        <br>（イギリス）</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap uk padb-20" id="ukview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap OpenSansFonts">
                                            <h3>London, United Kingdom</h3>
                                            <p class="marb-10">Woodberry House, 2 Woodberry Grove, Finchley, London, N12 0DR, United Kingdom
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap turkey" id="turkey" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name OpenSansFonts">イスタンブール
                                        <br />（トルコ）</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap turkey padb-20" id="turkeyview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap OpenSansFonts">
                                            <h3>Istanbul, Turkey</h3>
                                            <p class="marb-10">Levent Mah. Ulgen Sok. No:52 Besiktas Istanbul, TURKEY
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap taiwan" id="taiwan" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name OpenSansFonts">台北
                                        <br>（台湾）</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap taiwan padb-20" id="taiwanview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap OpenSansFonts">
                                            <h3>Taipei, Taiwan</h3>
                                            <p class="marb-10">
                                                2F, No. 40, Ln 91, Sec.1,
                                                <br> Neihu Road, Neihu Dist., Taipei City 11441, Taiwan.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="no_of_glance_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="glance_heading">
                        <div class="howItWorkHeading lineWhiteColor">
                            <h2>数値で見る
                                <br>クリムゾンインタラクティブ</h2>
                            <div class="HeadingSubLine"></div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="glance_contents">
                        <div class="row">
                            <div class="col-md-6 col-sm-6">
                                <div class="glance_container">
                                    <div class="glance_icons">
                                        <img src="assets/images/Aboutus-author.png" alt="著者 - 文法 チェック">
                                    </div>
                                    <p>世界中で支援させていただいた
                                        <br> 研究者数200万人以上
                                    </p>
                                </div>
                            </div>

                            <div class="col-md-6 col-sm-6">
                                <div class="glance_container">
                                    <div class="glance_icons">
                                        <img src="assets/images/aboutus_satisfy.png" alt="について - 英文校正">
                                    </div>
                                    <p>99.45%
                                        <br />の顧客満足度</p>
                                </div>
                            </div>

                            <div class="col-md-6 col-sm-6">
                                <div class="glance_container">
                                    <div class="glance_icons">
                                        <img src="assets/images/aboutus_degree_cap.png" alt="程度 - 文法 チェック">
                                    </div>
                                    <p>2000人以上の博士／修士号
                                        <br>保有者と契約</p>
                                </div>
                            </div>

                            <div class="col-md-6 col-sm-6">
                                <div class="glance_container">
                                    <div class="glance_icons">
                                        <img src="assets/images/globe.svg" alt="グローブ - ai英文校正" style="width: 40px;">
                                    </div>
                                    <p>125以上の国で
                                        <br>事業を展開</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="about_us_our_client">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>お客様</h2>
                    <div class="HeadingSubLine"></div>
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#UniversityPartners" role="tab">大学</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#Corporates_sections" role="tab">企業</a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane active" id="UniversityPartners" role="tabpanel">
                            <ul>
                                <li>
                                    <img src="assets/images/client_logos/Columbia_Univ_207.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/Duke_Univ.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/Priceton_Univ.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/Purdue_Univ.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/MIT.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/Technical-University-of-Denmark.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/Univ_of_Birmingham.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/Yonsei_University.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/University_of_Gassgow.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/Washinton_State_Univ.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/Korea_University.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/KyotoUniversityLogo.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/Peking-University.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/Tsinghua_University79.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/client_logos/University_of_Tokyo.png" alt="">
                                </li>
                            </ul>
                        </div>
                        <div class="tab-pane" id="Corporates_sections" role="tabpanel">
                            <ul>
                                <li>
                                    <img src="assets/images/Corporates_logos/wiley-logo.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/IBMWatson-logo.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/bombay-stock.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/Netflix-logo.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/toyota_log.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/guiness_world_Recodos.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/oup.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/Johnson-logo.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/sony_logo.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/bankofjapan.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/abbott.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/FujiTsu_logo.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/DowJones-logo.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/canon_logo.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/pfizer-logo.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/sanofi_logo.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/RBS_logo.png" alt="">
                                </li>
                                <li>
                                    <img src="assets/images/Corporates_logos/iifl-logo.png" alt="">
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->

    <div class="awards_certifications">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>受賞歴・認証</h2>
                    <div class="HeadingSubLine"></div>
                    <div class="cover_wrapper">
                        <div id="client-logos" class="owl-carousel">
                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="assets/images/golden-bridge-medal.png" alt="golden bridge">
                                    </div>
                                    <p class="OpenSansFonts">The Golden Bridge Awards For Best Entrepreneur (Women)</p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="assets/images/pharma-award.png" alt="pharma-award">
                                    </div>
                                    <p class="OpenSansFonts">APAC CIO Outlook Top 10 Pharma & Life Science Tech Solution Providers</p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="assets/images/ksci.png" alt="ksci">
                                    </div>
                                    <p class="OpenSansFonts">Korea
                                        <br /> Satisfaction Consumer
                                        <br /> Index
                                    </p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="assets/images/bizz-award.png" alt="bizz">
                                    </div>
                                    <p class="OpenSansFonts">Bizz Award For Business Excellence</p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="assets/images/qms-award.png" alt="qms">
                                    </div>
                                    <p class="OpenSansFonts">The World Quality
                                        <br /> Commitment Award</p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="assets/images/red-awards.png" alt="red awards">
                                    </div>
                                    <p class="OpenSansFonts">Red Herring Top 100 Asia
                                        <br /> and Global Awards!</p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="assets/images/sme-award.png" alt="sme-award">
                                    </div>
                                    <p class="OpenSansFonts">Google SME Award</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="our_values_slider">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>クリムゾンインタラクティブの企業理念</h2>
                    <div class="HeadingSubLine"></div>
                    <div id="customers-testimonials" class="owl-carousel">
                        <div class="item">
                            <div class="shadow-effect">
                                <h4>社会的責務</h4>
                                <p>倫理的で透明性のある行動を通じ、社会や環境に影響を与え、持続可能な発展に貢献したいと考えています。</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="shadow-effect">
                                <h4>敬意</h4>
                                <p>文化、人、環境に敬意を払って向き合い、人々の期待に応えるため、揺るぎない努力をします。そして様々な文化を尊重し、真摯に接します。</p>
                            </div>
                        </div>

                        <div class="item">
                            <div class="shadow-effect">
                                <h4>Wow</h4>
                                <p>私たちの価値観の根幹にあるのは「Wow」、つまり「驚き」です。お客様の世界とのコミュニケーションをより良いものにするお手伝いや革新的サービスの提供により、お客様の期待を超え、お客様の「Wow」を実現しようとします。
                                </p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="shadow-effect">
                                <h4>カイゼン</h4>
                                <p>継続的な改善を意味する「カイゼン」は、私たちのすべてのサービスの中核です。技術革新と努力の両輪により、絶え間ない改善を行っていきます。</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="shadow-effect">
                                <h4>イノベーション</h4>
                                <p>私たちは、すでに出来上がった方法にとらわれることなく、新たな方法を探り続けることでミッションを遂行していきます。</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="shadow-effect">
                                <h4>シンプリシティ</h4>
                                <p>最先端の技術に裏打ちされたシンプルなプロセスにより、高い品質を高い効率で生み出します。使いやすいインターフェース、見やすいウェブサイト、明確なサービス条件、カスタマイズ可能なサービスなどにこの原則が反映されています。</p>
                            </div>
                        </div>

                    </div>
                    <div class="slider_background_shadow"></div>

                </div>
            </div>
        </div>
    </div>
    <div class="about_us_footer_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="footer_sections_abouts">
                        <p>「進化を続けるIT技術や言語処理技術の世界で、自分の専門性やアイデアを活かしてみたい。」
                            <br>そう考えている皆さんと、私たちは一緒に働きたいと考えています。</p>
                        <a href="https://www.trinka.ai/jp/workwithus/" target="_blank">求人に応募する</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>